var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "whatsapp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6,6.32A7.85,7.85,0,0,0,12,4,7.94,7.94,0,0,0,5.12,15.89L4,20l4.2-1.1a7.93,7.93,0,0,0,3.79,1h0a8,8,0,0,0,8-7.93A8,8,0,0,0,17.6,6.32ZM12,18.53a6.58,6.58,0,0,1-3.36-.92l-.24-.15-2.49.66.66-2.43-.16-.25A6.6,6.6,0,0,1,16.66,7.27a6.65,6.65,0,0,1,2,4.66A6.66,6.66,0,0,1,12,18.53Zm3.61-4.94c-.2-.1-1.17-.58-1.35-.64s-.32-.1-.45.1a9,9,0,0,1-.63.77c-.11.14-.23.15-.43,0a5.33,5.33,0,0,1-2.69-2.35c-.21-.35.2-.33.58-1.08a.38.38,0,0,0,0-.35c0-.1-.45-1.08-.61-1.47s-.32-.33-.45-.34H9.19a.71.71,0,0,0-.53.25A2.19,2.19,0,0,0,8,10.17a3.82,3.82,0,0,0,.81,2.05,8.89,8.89,0,0,0,3.39,3,3.85,3.85,0,0,0,2.38.5,2,2,0,0,0,1.33-.94,1.62,1.62,0,0,0,.12-.94C15.94,13.74,15.81,13.69,15.61,13.59Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.49798a692b87e7b3d5df74110d8f7d95.svg";
export { ForwardRef as ReactComponent };